import PropTypes from 'prop-types';
import { commonPropTypes, } from '../../interfaces/commonProps';
import { spacingPropTypes } from '../../interfaces/layoutProps';
export var AccordionHeadingLevels;
(function (AccordionHeadingLevels) {
    AccordionHeadingLevels["h1"] = "h1";
    AccordionHeadingLevels["h2"] = "h2";
    AccordionHeadingLevels["h3"] = "h3";
    AccordionHeadingLevels["h4"] = "h4";
    AccordionHeadingLevels["h5"] = "h5";
    AccordionHeadingLevels["h6"] = "h6";
})(AccordionHeadingLevels || (AccordionHeadingLevels = {}));
export const accordionPropTypes = {
    multiple: PropTypes.bool,
    ...commonPropTypes,
    ...spacingPropTypes,
};
export const accordionSectionPropTypes = {
    id: PropTypes.string.isRequired,
    headingLevel: PropTypes.oneOf(Object.values(AccordionHeadingLevels)).isRequired,
    label: PropTypes.string.isRequired,
    defaultOpen: PropTypes.bool,
    roleRegion: PropTypes.bool,
    onToggle: PropTypes.func,
    icon: PropTypes.node,
    open: PropTypes.bool,
};
//# sourceMappingURL=Accordion.types.js.map